export const WithdrawBadge = () => {
	return (
		<div className="inline-flex items-center gap-2 rounded-lg border px-3 py-1 text-xs font-medium text-gray-700 bg-gray-50 border-gray-300/50">
			<div className={`size-2 rounded-full bg-gray-500`} />
			Withdraw
		</div>
	);
};
